var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplorar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.512,
    height: 10.725,
    viewBox: "0 0 12.512 10.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-arrow-right",
    "data-name": "Icon metro-arrow-right",
    d: "M12.281,16.247l4.469-4.469a.894.894,0,0,0,0-1.264L12.281,6.046A.894.894,0,1,0,11.017,7.31l2.943,2.943H5.392a.894.894,0,0,0,0,1.787H13.96l-2.943,2.943a.894.894,0,0,0,1.264,1.264Z",
    transform: "translate(-4.499 -5.784)",
    fill: "#81d742"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorar);
export default __webpack_public_path__ + "static/media/Explorar.8730e6a413bd2acca203263e248651ae.svg";
export { ForwardRef as ReactComponent };